<template>
  <div id="app">
    <md-toolbar id="tool-bar">
      <!-- <md-button href="/#/" class="md-icon-button">
        <md-icon>home</md-icon>
      </md-button> -->
      <md-button
        class="md-icon-button"
        @click="toggleLeftSidenav">
        <md-icon>menu</md-icon>
      </md-button>
      <span class="spacer"></span>
      <h1 class="md-title text-center">
        SetDancePal
      </h1>
      <span class="spacer"></span>
      <md-button class="md-icon-button no-display">
        <md-icon>search</md-icon>
      </md-button>
      <!-- <md-button v-if="!enableSearch" class="md-icon-button" @click="showSearchBar">
        <md-icon>search</md-icon>
      </md-button>
      <md-button v-if="enableSearch" class="md-icon-button no-display">
        <md-icon>search</md-icon>
      </md-button>
      <md-button class="md-icon-button" @click="showSearchBar">
        <md-icon>more_vert</md-icon>
      </md-button>

      <transition name="">
        <md-input-container v-if="enableSearch" md-clearable>
          <md-icon>search</md-icon>
          <md-input v-model="searchKey" @input="searchSet($event)" id="serachField" placeholder="Set name"></md-input>
        </md-input-container>
      </transition> -->
    </md-toolbar>

    <md-sidenav
      md-swipeable
      class="main-sidebar md-left md-fixed"
      ref="leftSidenav"
      @open="open('Left')"
      @close="close('Left')">
      <md-toolbar class="md-small">
        <div class="md-toolbar-container">
          <h3 class="md-title">メニュー</h3>
        </div>
      </md-toolbar>

      <md-divider></md-divider>

      <md-list>
        <md-list-item>
          <router-link :to="{ name: 'Home' }" exact>
            <span @click="closeSideBar">ホーム</span>
          </router-link>
        </md-list-item>

        <md-divider></md-divider>

        <md-list-item>
            <md-icon>event_available</md-icon>
            <div class="md-list-text-container">
              <span>開催中のイベント <md-chip class="md-primary">{{ countTodaysEvent() }}件</md-chip></span>
            </div>
            <!-- v-show="countTodaysEvent > 0"
            :key="todaysEvent" -->
            <md-list-expand>
                <md-list class="md-dense">
                  <md-list-item
                    v-for="event, index in events"
                    v-if="(new Date(event.dateTime).getFullYear() === new Date().getFullYear()) && (new Date(event.dateTime).getMonth() === new Date().getMonth()) && (new Date(event.dateTime).getDate() === new Date().getDate())"
                    :key="index">
                    <router-link
                      :to="{ name: 'Event', params: { eventId: event.id }}"
                      class="md-inset">
                      <span @click="closeSideBar">{{ event.name }}</span>
                    </router-link>
                  </md-list-item>
                </md-list>
            </md-list-expand>
        </md-list-item>

        <md-list-item>
          <md-icon>event</md-icon>
          <div class="md-list-text-container">
              <span>イベント</span>
          </div>
          <md-list-expand>
              <md-list class="md-dense">
                <md-list-item
                  v-for="event, index in events"
                  v-if="(event.dateTime > new Date()) || (new Date() - new Date(event.date) <= 86400000)"
                  :key="index">
                  <router-link
                    :to="{ name: 'Event', params: { eventId: event.id }}"
                    class="md-inset">
                    <span @click="closeSideBar">{{ getEventDate(event.startTime) }}　{{ event.name }}</span>
                  </router-link>
                </md-list-item>
              </md-list>
          </md-list-expand>
        </md-list-item>

        <md-list-item>
          <md-icon>view_list</md-icon>
          <div class="md-list-text-container">
            <span>セットリスト</span>
          </div>
          <md-list-expand>
              <md-list class="md-dense">
                <!-- <md-list-item v-for="set, index in originalSetList" :key="index"> -->
                <md-list-item
                  v-for="set, index in sets"
                  :key="index">
                  <router-link
                    v-if="set.needsSet"
                    :to="{ name: 'Set', params: { setName: set.name }}"
                    class="md-inset">
                    <span @click="closeSideBar">{{ set.name }} Set</span>
                  </router-link>
                  <router-link
                    v-else
                    :to="{ name: 'Set', params: { setName: set.name }}"
                    class="md-inset">
                    <span @click="closeSideBar">{{ set.name }}</span>
                  </router-link>
                </md-list-item>
              </md-list>
          </md-list-expand>
        </md-list-item>

        <md-list-item>
          <router-link :to="{ name: 'ForVisitor' }">
            <md-icon>info</md-icon>
            <span @click="closeSideBar">はじめての方へ</span>
          </router-link>
        </md-list-item>

        <md-list-item>
          <router-link :to="{ name: 'Reference' }">
            <md-icon>school</md-icon>
            <span @click="closeSideBar">リファレンスサイト</span>
          </router-link>
        </md-list-item>

        <md-list-item>
          <router-link :to="{ name: 'AllArticles' }">
            <md-icon>school</md-icon>
            <span @click="closeSideBar">ダンスの記事</span>
          </router-link>
        </md-list-item>

        <md-list-item>
          <router-link :to="{ name: 'EventOfIreland' }">
            <md-icon>school</md-icon>
            <span @click="closeSideBar">アイルランドのダンスクラス</span>
          </router-link>
        </md-list-item>

        <md-list-item>
          <router-link :to="{ name: 'SetMap' }">
            <md-icon>map</md-icon>
            <span @click="closeSideBar">セットの出身地</span>
          </router-link>
        </md-list-item>

        <!-- <md-list-item>
          <router-link :to="{ name: 'Hornpipes' }">
            <md-icon>compare_arrows</md-icon>
            <span @click="closeSideBar">ホーンパイプ比較表</span>
          </router-link>
        </md-list-item> -->

        <md-list-item>
          <router-link :to="{ name: 'Waltz' }">
            <md-icon>people</md-icon>
            <span @click="closeSideBar">ワルツについて</span>
          </router-link>
        </md-list-item>

        <md-list-item>
          <router-link :to="{ name: 'About' }">
            <span @click="closeSideBar">このサイトについて</span>
          </router-link>
        </md-list-item>
      </md-list>
    </md-sidenav>

    <div class="header">
    </div>

    <div
      v-show="!searchKeyInput"
      @click="hideSearchBar"
      class="content">
      <router-view></router-view>
    </div>
    <md-list
      v-show="searchKeyInput"
      v-for="(set, index) in sets"
      :key="index"
      id="filterdSet"
      class="md-double-line">
      <md-list-item>
        <md-avatar>
          <img
            :src="set.figures[0].youtube ? getThumbnail(set.figures[0].youtube.url) : getThumbnail(set.thumbnail)"
            alt="Thumbnail" />
        </md-avatar>
        <div class="md-list-text-container">
          <span>
            <router-link
              @click.native="closeSearchBar"
              :to="{ name: 'Set', params: { setName: set.name }}">
              {{ set.name }} Set
            </router-link>
          </span>
          <span class="jpCaption">
            {{ set.jpCaption }}
          </span>
        </div>
        <md-divider></md-divider>
      </md-list-item>
    </md-list>
  </div>
</template>

<script>
import db from './db'
import { getIdFromURL } from 'vue-youtube-embed'

export default {
  name: 'app',
  data () {
    return {
      enableSearch: false,
      searchKey: '',
      originalSetList: null
    }
  },
  firebase: {
    sets: db.ref('/sets'),
    events: db.ref('/events').orderByChild('dateTime')
  },
  computed: {
    searchKeyInput () {
      return this.searchKey.length > 0
    }
  },
  created () {
    window.addEventListener('error', function (e) {
      let message = e.message
      let filename = e.filename
      let lineNumber = e.lineno
      let columnNumber = e.colnoa
      let newErrorRef = db.ref('/errors').push()

      newErrorRef.set({
        id: newErrorRef.key,
        dateTime: Date.parse(new Date()),
        index: Date.parse(new Date()) * -1,
        message: message,
        filename: filename,
        lineNumber: lineNumber,
        columnNumber: columnNumber
      }).then(function () {
        console.log('Save Error Log.', message, filename, lineNumber, columnNumber)
      })
    })
  },
  methods: {
    getEventDate: function (startTime) {
      startTime = new Date(startTime)
      // startTime.getFullYear() + '年' +
      return (startTime.getMonth() + 1) + '/' + startTime.getDate() + '(' + (['日', '月', '火', '水', '木', '金', '土'][new Date(startTime).getDay()]) + ') '
    },
    getThumbnail: function (url) {
      return 'https://i.ytimg.com/vi/' + getIdFromURL(url) + '/mqdefault.jpg'
    },
    toggleLeftSidenav () {
      this.$refs.leftSidenav.toggle()
    },
    countTodaysEvent () {
      return this.events.filter(function (event) { return (new Date(event.dateTime).getFullYear() === new Date().getFullYear()) && (new Date(event.dateTime).getMonth() === new Date().getMonth()) && (new Date(event.dateTime).getDate() === new Date().getDate()) }).length
    },
    showSearchBar () {
      this.enableSearch = true
      // document.getElementById('serachField').focus()
      document.getElementById('tool-bar').classList.add('md-large')
    },
    hideSearchBar () {
      this.enableSearch = false
      document.getElementById('tool-bar').classList.remove('md-large')
    },
    closeSearchBar () {
      this.searchKey = ''
      this.sets = this.originalSetList
      this.enableSearch = false
      document.getElementById('tool-bar').classList.remove('md-large')
    },
    searchSet: function (value) {
      if (value !== undefined && value.length > 0) {
        if (this.originalSetList === null) {
          this.originalSetList = this.sets
        }
        this.sets = this.originalSetList.filter(function (set) { return set.name.toLowerCase().indexOf(value.toLowerCase()) >= 0 })
      } else {
        this.sets = this.originalSetList
      }
    },
    closeSideBar () {
      this.$refs.leftSidenav.close()
    },
    open (ref) {
      // console.log('Opened: ' + ref)
    },
    close (ref) {
      // console.log('Closed: ' + ref)
    }
  }
}
</script>

<style>
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-bottom: 24px;
}

ul#filterdSet {
  padding: 0;
}

.md-avatar {
  overflow: inherit;
  width: 71px;
  max-width: 71px;
}

.spacer {
    flex: 1 1 auto;
}
.controller {
  margin-top: 24px;
  padding-bottom: 24px;
}

.page-description {
  padding: 0 12px;
}

.fade-enter-active, .fade-leave-active {
  transition: opacity .5s
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0
}

.md-button.no-display {
  cursor: inherit;
  opacity: 0;
}

.launchButton i {
  margin-bottom: 2px;
  font-size: 16px;
  vertical-align: middle;
}

.main-sidebar.md-sidenav {
  .md-sidenav-content {
    width: $sizebar-size;
    display: flex;
    flex-flow: column;
    overflow: hidden;
    @media (min-width: 1281px) {
      top: 0;
      pointer-events: auto;
      transform: translate3d(0, 0, 0) !important;
      box-shadow: $material-shadow-2dp;
    }
  }
}

#view-setting.md-speed-dial [md-fab-trigger] {
  position: fixed;
  right: 8px;
  bottom: 8px;
}

.md-speed-dial.md-direction-top [md-fab-trigger] ~ .md-button {
  right: 16px;
  position: fixed;
}

.md-speed-dial.md-direction-top [md-fab-trigger] ~ .md-button:nth-child(2) {
  bottom: 70px;
}

.md-speed-dial.md-direction-top [md-fab-trigger] ~ .md-button:nth-child(3) {
  bottom: 122px;
}

.md-speed-dial.md-direction-top [md-fab-trigger] ~ .md-button:nth-child(4) {
  bottom: 172px;
}

.footer {
    /*margin-bottom: 50px;*/
}
</style>



// WEBPACK FOOTER //
// App.vue?0f78fe04